import Button from "@mui/material/Button";

interface GoogleButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

/** Native-MUI trigger for the shared Google authentication action. */
export function GoogleButton({
  onClick,
  disabled = false,
  label = "Continue with Google",
}: GoogleButtonProps) {
  return (
    <Button
      type="button"
      variant="text"
      size="small"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      sx={{
        color: "text.primary",
        borderRadius: "10px",
        fontWeight: 700,
        bgcolor: "action.hover",
        "&:hover": { bgcolor: "action.selected" },
      }}
    >
      {label}
    </Button>
  );
}
